import { WithContext } from 'schema-dts';
import { Organization, WebSite, WebPage, BreadcrumbList, Article, LocalBusiness } from 'schema-dts';

export const organizationSchema: WithContext<Organization> = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://openlabsresearch.com/#organization",
  "name": "OpenLabs Research",
  "url": "https://openlabsresearch.com",
  "logo": "https://openlabsresearch.com/images/logo.png",
  "description": "Leading AI research and development company in Australia & New Zealand",
  "sameAs": [
    "https://www.linkedin.com/company/openlabs-research",
    "https://twitter.com/openlabs_ai"
  ],
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Sydney",
    "addressRegion": "NSW",
    "addressCountry": "AU",
    "postalCode": "2000"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "email": "contact@openlabsresearch.com",
    "telephone": "+61000000000"
  }
};

export function generateBreadcrumbList(items: { name: string; item: string }[]): WithContext<BreadcrumbList> {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://openlabsresearch.com${item.item}`
    }))
  };
}

export function generateArticleSchema(article: {
  headline: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  author: string;
}): WithContext<Article> {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.headline,
    "description": article.description,
    "image": article.image.startsWith('http') ? article.image : `https://openlabsresearch.com${article.image}`,
    "datePublished": article.datePublished,
    "dateModified": article.dateModified,
    "author": {
      "@type": "Person",
      "name": article.author
    },
    "publisher": {
      "@type": "Organization",
      "name": "OpenLabs Research",
      "logo": {
        "@type": "ImageObject",
        "url": "https://openlabsresearch.com/images/logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://openlabsresearch.com"
    }
  };
}

export const localBusinessSchema: WithContext<LocalBusiness> = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "OpenLabs Research",
  "image": "https://openlabsresearch.com/images/logo.png",
  "@id": "https://openlabsresearch.com",
  "url": "https://openlabsresearch.com",
  "telephone": "+61000000000",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "123 Tech Street",
    "addressLocality": "Sydney",
    "addressRegion": "NSW",
    "postalCode": "2000",
    "addressCountry": "AU"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": -33.8688,
    "longitude": 151.2093
  },
  "sameAs": [
    "https://www.linkedin.com/company/openlabs-research",
    "https://twitter.com/openlabs_ai"
  ]
};
